const DEFAULT_BRANDING = {
  portalName: 'Sentinel Command',
  tagline: 'Cybersecurity Command Portal',
  description: 'Unified vulnerability management, compliance monitoring, and attack surface intelligence.',
  primaryColor: '#1a1a2e',
  secondaryColor: '#e94560',
  backgroundColor: '#ffffff',
  surfaceColor: '#f8f9fb',
  textColor: '#1a1a2e',
  fontFamily: 'default',
  logoUrl: '',
  logoLetter: 'S',
  customDomain: '',
  oidcEnabled: false,
  oidcTenantId: '',
  oidcAuthority: null,
  oidcClientId: null,
  oidcScopes: 'openid profile email',
  oidcAllowedDomains: '',
  oidcAllowJitProvisioning: false,
  oidcDefaultRole: 'MspReader',
  oidcClientSecretConfigured: false,
  hasCustomOidc: false,
  features: [],
};

export async function fetchBranding({ mspId } = {}) {
  try {
    const base = import.meta.env.VITE_API_BASE_URL || '';
    let url;
    if (mspId) {
      url = `${base}/branding?mspId=${encodeURIComponent(mspId)}`;
    } else {
      const domain = import.meta.env.VITE_FORCE_DOMAIN || window.location.hostname;
      url = `${base}/branding?domain=${encodeURIComponent(domain)}`;
    }
    const res = await fetch(url);
    if (!res.ok) return { ...DEFAULT_BRANDING, _loadState: 'error' };
    const data = await res.json();
    return { ...DEFAULT_BRANDING, ...data, _loadState: 'loaded' };
  } catch {
    return { ...DEFAULT_BRANDING, _loadState: 'error' };
  }
}

export { DEFAULT_BRANDING };
